import { render, staticRenderFns } from "./downloadH5.vue?vue&type=template&id=6df5f86a&scoped=true&"
import script from "./downloadH5.vue?vue&type=script&lang=js&"
export * from "./downloadH5.vue?vue&type=script&lang=js&"
import style0 from "./downloadH5.vue?vue&type=style&index=0&id=6df5f86a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df5f86a",
  null
  
)

export default component.exports